/* Holds IP of Special Servers */
export const SpecialServers: {
  [key: string]: string | undefined;

  Home: string;
  FulcrumSecretTechnologies: string;
  CyberSecServer: string;
  NiteSecServer: string;
  TheBlackHandServer: string;
  BitRunnersServer: string;
  TheDarkArmyServer: string;
  DaedalusServer: string;
  WorldDaemon: string;
  DarkWeb: string;
} = {
  Home: "home",
  FulcrumSecretTechnologies: "fulcrumassets",
  CyberSecServer: "CSEC",
  NiteSecServer: "avmnite-02h",
  TheBlackHandServer: "I.I.I.I",
  BitRunnersServer: "run4theh111z",
  TheDarkArmyServer: ".",
  DaedalusServer: "The-Cave",
  WorldDaemon: "w0r1d_d43m0n",
  DarkWeb: "darkweb",
};
